if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");

				this.submitButton = this.querySelector('[type="submit"]');

				if (document.querySelector("cart-drawer")) {
					this.submitButton.setAttribute("aria-haspopup", "dialog");
				}

				this.hideErrors = this.dataset.hideErrors === "true";
			}

			getSaftkurCalloutAddons() {
				const card = this.closest(".SaftkurCallout__product-card");

				if (!card) {
					return [];
				}

				const productFormId = this.form ? this.form.id : "";

				let addonContainer = null;

				if (productFormId) {
					addonContainer = Array.from(
						card.querySelectorAll("[data-js-addon-container]")
					).find((container) => {
						return (
							container.getAttribute("data-product-form-id") ===
							productFormId
						);
					});
				}

				if (!addonContainer) {
					addonContainer = card.querySelector("[data-js-addon-container]");
				}

				if (!addonContainer) {
					return [];
				}

				const parentHandle =
					addonContainer.getAttribute("data-parent-handle") || "";

				const parentVariantId =
					addonContainer.getAttribute("data-parent-variant-id") || "";

				const addons = [];

				addonContainer
					.querySelectorAll(
						'input[type="checkbox"][data-addon-variant-id]:checked'
					)
					.forEach((checkbox) => {
						const variantId = parseInt(
							checkbox.getAttribute("data-addon-variant-id"),
							10
						);

						if (!Number.isFinite(variantId) || variantId <= 0) {
							return;
						}

						addons.push({
							id: variantId,
							quantity: 1,
							properties: {
								_addon: "true",
								_addon_for: parentHandle,
								_addon_for_variant: parentVariantId,
							},
						});
					});

				console.warn(
					"[LF PRODUCT FORM] Saftkur add-ons collected",
					{
						formId: productFormId,
						parentVariantId: parentVariantId,
						addons: addons,
					}
				);

				return addons;
			}

			onSubmitHandler(evt) {
				evt.preventDefault();

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");

				this.querySelector(".loading-overlay__spinner").classList.remove(
					"hidden"
				);

				const openCartButton = document.querySelector(
					'#cart-icon-bubble[role="button"]'
				);

				const formData = new FormData(this.form);

				let cartItems;

				// The input is set to "0" for variants without Pfand, and "0" is a truthy
				// string — testing it directly queued a deposit line of quantity 0.
				const depositPerUnit =
					Number(formData.get("deposit-variant-amount")) || 0;

				if (depositPerUnit > 0) {
					let qtyDepost =
						depositPerUnit * formData.get("quantity") ||
						depositPerUnit;

					cartItems = {
						items: [
							{
								id: formData.get("deposit-variant-id"),
								quantity: qtyDepost,
							},
							{
								id: formData.get("id"),
								quantity: formData.get("quantity"),
								selling_plan: formData.get("selling_plan"),
								properties: {
									_deposit_amount: formData.get(
										"deposit-variant-amount"
									),
								},
							},
						],
					};
				} else {
					cartItems = {
						items: [
							{
								id: formData.get("id"),
								quantity: formData.get("quantity"),
								selling_plan: formData.get("selling_plan"),
							},
						],
					};
				}

				/*
				 * SAFTKUR CALLOUT ADD-ONS
				 *
				 * If this product-form belongs to one of the Saftkur Callout cards,
				 * collect only the checked add-ons belonging to the same card and
				 * append them directly to the Shopify cart/add.js request.
				 *
				 * Normal PDP product forms are not affected.
				 */
				const saftkurAddons = this.getSaftkurCalloutAddons();

				if (saftkurAddons.length) {
					cartItems.items.push(...saftkurAddons);
				}

				console.warn(
					"[LF PRODUCT FORM] final cart/add payload",
					cartItems
				);

				fetch(window.Shopify.routes.root + "cart/add.js", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(cartItems),
				})
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});

							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(
									".sold-out-message"
								);

							if (!soldOutMessage) {
								return;
							}

							this.submitButton.setAttribute(
								"aria-disabled",
								true
							);

							this.submitButton
								.querySelector("span")
								.classList.add("hidden");

							this.querySelector(
								".loading-overlay__spinner"
							).classList.add("hidden");

							soldOutMessage.classList.remove("hidden");

							this.error = true;

							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						fetch(window.location.href)
							.then((response) => response.text())
							.then((responseText) => {
								const html = new DOMParser().parseFromString(
									responseText,
									"text/html"
								);

								const oldDrawer =
									document.querySelector("cart-drawer");

								const newDrawer =
									html.querySelector("cart-drawer");

								const oldIconCart =
									document.querySelector(
										"#cart-icon-bubble"
									);

								const newIconCart =
									html.querySelector(
										"#cart-icon-bubble"
									);

								if (oldIconCart && newIconCart) {
									oldIconCart.innerHTML =
										newIconCart.innerHTML;
								}

								if (oldDrawer && newDrawer) {
									oldDrawer.innerHTML =
										newDrawer.innerHTML;
								}

								if (response.item_count == 0) {
									document
										.querySelector("cart-drawer")
										.classList.add("is-empty");
								} else {
									document
										.querySelector("cart-drawer")
										.classList.remove("is-empty");
								}

								document.dispatchEvent(
									new CustomEvent("rerenderCart")
								);
							})
							.catch((e) => {
								console.error(e);
							})
							.finally(() => {
								this.submitButton.classList.remove(
									"loading"
								);

								if (
									this.cart &&
									this.cart.classList.contains("is-empty")
								) {
									this.cart.classList.remove("is-empty");
								}

								if (!this.error) {
									this.submitButton.removeAttribute(
										"aria-disabled"
									);
								}

								this.querySelector(
									".loading-overlay__spinner"
								).classList.add("hidden");

								setTimeout(() => {
									const cartButton =
										document.querySelector(
											"#cart-icon-bubble"
										);

									if (cartButton) {
										cartButton.click();
									}
								}, 200);
							});
					});

				// open cart
				setTimeout(() => {
					if (openCartButton) {
						openCartButton.click();
					}
				}, 500);
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(
						".product-form__error-message-wrapper"
					);

				if (!this.errorMessageWrapper) return;

				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute(
					"hidden",
					!errorMessage
				);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}